import { apiSlice } from "../../../api/apiSlice";
import { EMPLOYEE_DIMENSION_HISTORY } from "../../../constants";

export const employeeDimensionHistorySlice = apiSlice.injectEndpoints({
    endpoints: (builder: any) => ({
        getEmployeeDimensionHistory: builder.query({
            query: (arg: any) => {
                const { employeenumber, year, month } = arg;
                return {
                    url: EMPLOYEE_DIMENSION_HISTORY,
                    params: { employeenumber, year, month },
                };
            },         
        }),
    }),
});

export const {
    useGetEmployeeDimensionHistoryQuery,
} = employeeDimensionHistorySlice;
